/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { Route, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Login from './Login/Login';
import {
  getPendingAccessoryTransferRequestCount,
  getPendingFabricTransferRequestCount,
  getRPOPendingCount,
  login,
} from './Actions';
import Routes from './Routes';
import './App.css';

const App = () => {
  const auth = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(login())
      // .then(() => {
      //   dispatch(getPendingFabricTransferRequestCount());
      //   dispatch(getPendingAccessoryTransferRequestCount());
      //   dispatch(getRPOPendingCount());

      //   setInterval(() => {
      //     dispatch(getPendingFabricTransferRequestCount());
      //     dispatch(getPendingAccessoryTransferRequestCount());
      //     dispatch(getRPOPendingCount());
      //   }, 120000);
      // })
      .catch(() => {
        history.push('/login');
      });
  }, []);

  return (
    <>
      <Route path="/login" exact component={Login} />
      {auth.type && auth.user ? <Routes /> : null}
    </>
  );
};

export default App;
